import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Browse from "../pages/browse/page";
import Listing from "../pages/listing/page";
import BecomeHost from "../pages/become-host/page";
import HowItWorks from "../pages/how-it-works/page";
import Pricing from "../pages/pricing/page";
import Safety from "../pages/safety/page";
import Contact from "../pages/contact/page";
import ListSpace from "../pages/list-space/page";
import HelpCenter from "../pages/help-center/page";
import TrustSafety from "../pages/trust-safety/page";
import Terms from "../pages/terms/page";
import Privacy from "../pages/privacy/page";


import FAQs from "../pages/faq/page";
import Login from "../pages/login/page";
import SignUp from "../pages/signup/page";
import Profile from "../pages/profile/page";
import MyListings from "../pages/my-listings/page";
import RentalHistory from "../pages/rental-history/page";
import Earnings from "../pages/earnings/page";
import Bookings from "../pages/bookings/page";
import ReviewPage from "../pages/bookings/[id]/review/page";
import Messages from "../pages/messages/page";
import ConversationPage from "../pages/messages/[id]/page";
import Settings from "../pages/settings/page";
import EarningsCalculator from "../pages/earnings-calculator/page";
import GoldCoastHostLanding from "../pages/host/gold-coast/page";
import EmailVerified from "../pages/email-verified/page";
import FavouritesPage from "../pages/favourites/page";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import AustraliaHostLanding from "../pages/host/australia/page";
import CaravanStorageLanding from "../pages/host/caravan-storage/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/browse",
    element: <Browse />,
  },
  {
    path: "/listing/:id",
    element: <Listing />,
  },
  {
    path: "/list-space",
    element: <ProtectedRoute requireVerification={true}><ListSpace /></ProtectedRoute>,
  },
  {
    path: "/become-host",
    element: <BecomeHost />,
  },
  {
    path: "/how-it-works",
    element: <HowItWorks />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/safety",
    element: <Safety />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/help-center",
    element: <HelpCenter />,
  },
  {
    path: "/trust-safety",
    element: <TrustSafety />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },

  {
    path: "/faq",
    element: <FAQs />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/signup",
    element: <SignUp />,
  },
  {
    path: "/host/gold-coast",
    element: <GoldCoastHostLanding />,
  },
  {
    path: "/host/australia",
    element: <AustraliaHostLanding />,
  },
  {
    path: "/host/caravan-storage",
    element: <CaravanStorageLanding />,
  },
  {
    path: "/email-verified",
    element: <EmailVerified />,
  },
  {
    path: "/profile",
    element: <ProtectedRoute><Profile /></ProtectedRoute>,
  },
  {
    path: "/my-listings",
    element: <ProtectedRoute><MyListings /></ProtectedRoute>,
  },
  {
    path: "/rental-history",
    element: <ProtectedRoute><RentalHistory /></ProtectedRoute>,
  },
  {
    path: "/earnings",
    element: <ProtectedRoute><Earnings /></ProtectedRoute>,
  },
  {
    path: "/earnings-calculator",
    element: <EarningsCalculator />,
  },
  {
    path: "/bookings",
    element: <ProtectedRoute><Bookings /></ProtectedRoute>,
  },
  {
    path: "/bookings/:id/review",
    element: <ProtectedRoute><ReviewPage /></ProtectedRoute>,
  },
  {
    path: "/messages",
    element: <ProtectedRoute><Messages /></ProtectedRoute>,
  },
  {
    path: "/messages/:id",
    element: <ProtectedRoute><ConversationPage /></ProtectedRoute>,
  },
  {
    path: "/settings",
    element: <ProtectedRoute><Settings /></ProtectedRoute>,
  },
  {
    path: "/favourites",
    element: <ProtectedRoute><FavouritesPage /></ProtectedRoute>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;

